/*!
 * Lugg Reviews JS
 * Anyone can write a review — no purchase required, no eligibility check.
 * Guests supply email. Dedup is handled server-side on submit.
 *
 * The first page of reviews ships server-rendered from Liquid to avoid
 * layout shift on load. This script hydrates + wires up events against
 * that markup, and only rebuilds #lg-rv-list once the person actually
 * interacts (search / rating filter / sort / media toggle / pagination).
 */
(function () {
  'use strict';

  var RV = window.__LUGG_RV;
  if (!RV) return;

  var PRODUCT_ID     = RV.productId;
  var PRODUCT_HANDLE = RV.productHandle;
  var PRODUCT_TITLE  = RV.productTitle;
  var BASE           = (RV.reviewsUrl || '').replace(/\/$/, '');
  var AUTH           = RV.auth || '';
  var CUSTOMER_ID    = RV.customerId    || '';
  var CUSTOMER_EMAIL = RV.customerEmail || '';
  var CUSTOMER_NAME  = RV.customerName  || '';
  var IS_LOGGED_IN   = !!RV.isLoggedIn;

  var ALL_REVIEWS = RV.reviews    || [];
  var STATS       = RV.stats      || { avg:0, count:0, dist:{} };
  var SUMMARY     = RV.summary    || '';
  var HIGHLIGHTS  = RV.highlights || {};

  var PAGE_SIZE      = RV.pageSize || 8;
  var currentRating  = 0;
  var currentSort    = 'newest';
  var currentSearch  = '';
  var mediaOnly      = false;
  var currentPage    = 1;
  var filteredList   = ALL_REVIEWS.slice(); // matches server-rendered order at boot
  var pendingPhotos  = [];   // locally-cached photos {id,dataUrl,filename} — uploaded on submit
  var pendingSeq     = 0;
  var selRating      = 0;

  function $(id) { return document.getElementById(id); }
  function esc(s) { return String(s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }

  function fmtDate(iso) {
    if (!iso) return '';
    try { return new Date(iso).toLocaleDateString('en-GB', {day:'2-digit',month:'short',year:'numeric'}); }
    catch(e) { return iso; }
  }

  function starsSVG(r, cls, size) {
    var h = '';
    for (var i=1;i<=5;i++) {
      h += '<svg width="'+(size||14)+'" height="'+(size||14)+'" viewBox="0 0 24 24">' +
        '<polygon class="'+(i<=r?cls+'-on':cls+'-off')+'" points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26"/></svg>';
    }
    return h;
  }

  /* ---------------- Overall + rating bars ---------------- */

  function renderOverall() {
    var avgEl=$('lg-rv-avg'), starsEl=$('lg-rv-stars-row'), totEl=$('lg-rv-total-link');
    if(avgEl) avgEl.textContent = STATS.avg || '';
    if(starsEl) starsEl.innerHTML = starsSVG(Math.round(STATS.avg||0),'kr-s',16);
    if(totEl) totEl.addEventListener('click', function(){
      var list=$('lg-rv-list');
      if(list) window.scrollTo({top:list.getBoundingClientRect().top+window.scrollY-80,behavior:'smooth'});
    });
  }

  function renderBars() {
    var dist  = STATS.dist || {};
    var total = STATS.count || ALL_REVIEWS.length || 0;
    for (var s=1; s<=5; s++) {
      var cnt = Number(dist[s] || 0);
      var pct = total > 0 ? Math.round(cnt/total*100) : 0;
      var fill = document.querySelector('.lg-rv__bar-fill[data-star="'+s+'"]');
      var ct   = document.querySelector('.lg-rv__bar-count[data-star-ct="'+s+'"]');
      if (fill) fill.style.width = pct + '%';
      if (ct)   ct.textContent = cnt;
    }
  }

  function renderSummary() {
    var bullets=HIGHLIGHTS.bullets, ulEl=$('lg-rv-ai-bullets'), moreBtn=$('lg-rv-ai-more');
    if(!ulEl) return;
    var lines=[];
    if(bullets&&bullets.length){ lines=bullets; }
    else if(SUMMARY){ var parts=SUMMARY.split(/(?<=[.!?])\s+|—|–/); lines=parts.map(function(l){return l.trim();}).filter(Boolean).slice(0,3); }
    if(!lines.length) return;
    var showAll=false,max=3;
    function render(){
      ulEl.innerHTML='';
      (showAll?lines:lines.slice(0,max)).forEach(function(l){var li=document.createElement('li');li.textContent=l;ulEl.appendChild(li);});
      if(moreBtn){moreBtn.style.display=lines.length>max?'block':'none';moreBtn.textContent=showAll?'Show less':'Show more';}
    }
    render();
    if(moreBtn) moreBtn.addEventListener('click',function(){showAll=!showAll;render();});
  }

  /* ---------------- Customer photo gallery ---------------- */

  var galleryPhotos = [];
  function renderGallery() {
    galleryPhotos = [];
    ALL_REVIEWS.forEach(function(r){ if(r.photos&&r.photos.length) r.photos.forEach(function(u){galleryPhotos.push(u);}); });
    if(!galleryPhotos.length) return;
    var gallery=$('lg-rv-gallery'), strip=$('lg-rv-gallery-strip');
    if(!gallery||!strip) return;
    gallery.style.display='';
    strip.innerHTML = galleryPhotos.map(function(url,i){
      return '<img src="'+esc(url)+'" class="lg-rv__gallery-thumb" loading="lazy" alt="Customer photo" data-gi="'+i+'">';
    }).join('');
    strip.addEventListener('click', function(e){
      var img=e.target.closest('.lg-rv__gallery-thumb');
      if(!img) return;
      openLightbox(galleryPhotos, parseInt(img.dataset.gi,10));
    });
  }

  /* ---------------- Filter / sort / search ---------------- */

  function applyFilterSort() {
    var list = ALL_REVIEWS.slice();
    if (currentRating > 0) list = list.filter(function(r){ return r.rating === currentRating; });
    if (mediaOnly) list = list.filter(function(r){ return r.photos && r.photos.length > 0; });
    if (currentSearch) {
      var q = currentSearch.toLowerCase();
      list = list.filter(function(r){
        return (r.title||'').toLowerCase().indexOf(q) > -1 ||
               (r.body||'').toLowerCase().indexOf(q) > -1 ||
               (r.customerName||'').toLowerCase().indexOf(q) > -1;
      });
    }
    if(currentSort==='highest')     list.sort(function(a,b){return b.rating-a.rating;});
    else if(currentSort==='lowest') list.sort(function(a,b){return a.rating-b.rating;});
    else list.sort(function(a,b){return new Date(b.createdAt)-new Date(a.createdAt);});
    filteredList=list; currentPage=1; renderPage();
  }

  /* ---------------- Card rendering (client re-render only) ---------------- */

  function renderPage() {
    var listEl=$('lg-rv-list'); if(!listEl) return;
    var total=filteredList.length, start=(currentPage-1)*PAGE_SIZE, end=Math.min(start+PAGE_SIZE,total), page=filteredList.slice(start,end);
    listEl.innerHTML='';
    if (!page.length) {
      listEl.innerHTML = '<p style="padding:24px 0;font-size:14px;color:var(--rv-muted-foreground,#7a756c)">No reviews match your filters.</p>';
    } else {
      page.forEach(function(r,idx){ listEl.insertAdjacentHTML('beforeend', buildCard(r,start+idx)); });
    }
    updateMetaUI(total,start,end);
  }

  function updateMetaUI(total,start,end){
    if (total === undefined) {
      total = filteredList.length;
      start = (currentPage-1)*PAGE_SIZE;
      end = Math.min(start+PAGE_SIZE,total);
    }
    var showing = total>0 ? (start+1)+'–'+end+' of '+total+' review'+(total!==1?'s':'') : '0 reviews';
    var pageInfoEl=$('lg-rv-page-info');
    if(pageInfoEl) pageInfoEl.textContent=showing;
    var prevBtn=$('lg-rv-prev'), nextBtn=$('lg-rv-next');
    if(prevBtn) prevBtn.disabled = currentPage===1;
    if(nextBtn) nextBtn.disabled = end>=total;
  }

  function buildPhotosRow(photos, dataIdx) {
    if (!photos || !photos.length) return '';
    var extra = photos.length - 4;
    var imgs = photos.slice(0,4).map(function(u,pi){
      var isMore = (pi===3 && photos.length>4);
      return '<img src="'+esc(u)+'" class="lg-rv__card-photo'+(isMore?' kr-more':'')+'"'+(isMore?' data-more="+'+extra+'"':'')+' loading="lazy" alt="Review photo">';
    }).join('');
    return '<div class="lg-rv__card-photos" data-idx="'+dataIdx+'" data-pi="0">'+imgs+'</div>';
  }

  function buildCard(r, dataIdx) {
    var badge = '';
    if (r.source === 'amazon') badge = '<span class="rv-badge rv-badge--az">Amazon</span>';
    else if (r.tags && r.tags.indexOf('verified') > -1) badge = '<span class="rv-badge">Verified Buyer</span>';
    return '<div class="lg-rv__card" data-idx="'+dataIdx+'">' +
      '<div class="lg-rv__card-top">' +
        '<div class="lg-rv__card-who"><span class="lg-rv__card-name">'+esc(r.customerName||'Anonymous')+'</span>'+badge+'</div>' +
        '<span class="lg-rv__card-date">'+fmtDate(r.createdAt)+'</span>' +
      '</div>' +
      '<div class="lg-rv__card-stars-row">'+starsSVG(r.rating,'kr-c',14)+'</div>' +
      (r.title?'<p class="lg-rv__card-title">'+esc(r.title)+'</p>':'') +
      '<p class="lg-rv__card-body">'+esc(r.body)+'</p>' +
      buildPhotosRow(r.photos, dataIdx) +
    '</div>';
  }

  // Click delegation — works for both server-rendered and client-rendered cards
  var listEl=$('lg-rv-list');
  if(listEl) listEl.addEventListener('click', function(e){
    var target = e.target.closest('[data-pi]');
    if(!target) return;
    var idx=parseInt(target.dataset.idx,10), pi=parseInt(target.dataset.pi,10)||0;
    var r=filteredList[idx];
    if(r && r.photos && r.photos.length) openLightbox(r.photos, pi);
  });

  var prevBtn=$('lg-rv-prev'), nextBtn=$('lg-rv-next');
  if(prevBtn) prevBtn.addEventListener('click', function(){ if(currentPage>1){currentPage--;renderPage();scrollTop();} });
  if(nextBtn) nextBtn.addEventListener('click', function(){ if(currentPage*PAGE_SIZE<filteredList.length){currentPage++;renderPage();scrollTop();} });
  function scrollTop(){ var el=$('lg-rv-list'); if(el) window.scrollTo({top:el.getBoundingClientRect().top+window.scrollY-80,behavior:'smooth'}); }

  /* ---------------- Toolbar wiring ---------------- */

  var searchInput=$('lg-rv-search');
  if (searchInput) {
    var searchTimer;
    searchInput.addEventListener('input', function(){
      clearTimeout(searchTimer);
      var val=this.value;
      searchTimer=setTimeout(function(){ currentSearch=val.trim(); applyFilterSort(); }, 250);
    });
  }

  var mediaToggle=$('lg-rv-media-toggle');
  if (mediaToggle) mediaToggle.addEventListener('click', function(){
    mediaOnly = this.getAttribute('aria-pressed') !== 'true';
    this.setAttribute('aria-pressed', mediaOnly ? 'true' : 'false');
    applyFilterSort();
  });

  // Rating bar rows double as filters (click to toggle)
  document.querySelectorAll('.lg-rv__bar-row').forEach(function(row){
    row.addEventListener('click', function(){
      var star = parseInt(row.dataset.rating, 10);
      currentRating = (currentRating === star) ? 0 : star;
      document.querySelectorAll('.lg-rv__bar-row').forEach(function(r){ r.classList.toggle('is-active', parseInt(r.dataset.rating,10)===currentRating && currentRating>0); });
      applyFilterSort();
    });
  });

  /* ---------------- Custom shadcn-style Select ---------------- */

  function initSelect(root, onChange) {
    if (!root) return;
    var trigger = root.querySelector('.rv-select-trigger');
    var valueEl = root.querySelector('.rv-select-value');
    var items   = Array.prototype.slice.call(root.querySelectorAll('.rv-select-item'));
    var activeIndex = -1;

    function highlight(){ items.forEach(function(it,i){ it.classList.toggle('is-active', i===activeIndex); }); }
    function onDocClick(e){ if(!root.contains(e.target)) close(); }
    function onKeydown(e){
      if(e.key==='Escape'){ close(); trigger.focus(); return; }
      if(e.key==='ArrowDown'){ e.preventDefault(); activeIndex=Math.min(items.length-1, activeIndex+1); highlight(); }
      else if(e.key==='ArrowUp'){ e.preventDefault(); activeIndex=Math.max(0, activeIndex-1); highlight(); }
      else if(e.key==='Enter'){ e.preventDefault(); if(activeIndex>=0) select(items[activeIndex]); }
    }
    function open(){
      root.classList.add('is-open');
      trigger.setAttribute('aria-expanded','true');
      activeIndex = items.findIndex(function(i){ return i.getAttribute('aria-selected')==='true'; });
      highlight();
      document.addEventListener('click', onDocClick);
      document.addEventListener('keydown', onKeydown);
    }
    function close(){
      root.classList.remove('is-open');
      trigger.setAttribute('aria-expanded','false');
      document.removeEventListener('click', onDocClick);
      document.removeEventListener('keydown', onKeydown);
    }
    function select(item){
      items.forEach(function(it){ it.setAttribute('aria-selected', it===item ? 'true':'false'); });
      root.dataset.value = item.dataset.value;
      if(valueEl) valueEl.textContent = item.textContent.trim();
      close();
      onChange(item.dataset.value);
    }

    trigger.addEventListener('click', function(){ root.classList.contains('is-open') ? close() : open(); });
    items.forEach(function(item){
      item.addEventListener('click', function(){ select(item); });
      item.addEventListener('mouseenter', function(){ activeIndex=items.indexOf(item); highlight(); });
    });
  }

  initSelect($('lg-rv-sort'), function(value){ currentSort=value; applyFilterSort(); });

  /* ---------------- Lightbox with arrow navigation ---------------- */

  var lbImages=[], lbIndex=0;

  function renderLightbox(){
    var fi=$('lg-rv-fs-img'), countEl=$('lg-rv-fs-count');
    if(!fi) return;
    fi.src = lbImages[lbIndex];
    if(countEl) countEl.textContent = lbImages.length>1 ? (lbIndex+1)+' / '+lbImages.length : '';
    var prevBtn=$('lg-rv-fs-prev'), nextBtn=$('lg-rv-fs-next');
    var multi = lbImages.length>1;
    if(prevBtn) prevBtn.style.display = multi?'flex':'none';
    if(nextBtn) nextBtn.style.display = multi?'flex':'none';
  }
  function openLightbox(images, startIndex){
    lbImages=images||[]; lbIndex=startIndex||0;
    if(!lbImages.length) return;
    var fs=$('lg-rv-fs'); if(!fs) return;
    renderLightbox();
    fs.classList.add('is-open');
    document.body.style.overflow='hidden';
  }
  function closeLightbox(){
    var fs=$('lg-rv-fs'), fi=$('lg-rv-fs-img');
    if(fs) fs.classList.remove('is-open');
    if(fi) fi.src='';
    document.body.style.overflow='';
  }
  function lbPrev(){ if(!lbImages.length) return; lbIndex=(lbIndex-1+lbImages.length)%lbImages.length; renderLightbox(); }
  function lbNext(){ if(!lbImages.length) return; lbIndex=(lbIndex+1)%lbImages.length; renderLightbox(); }

  var fsX=$('lg-rv-fs-x'), fsBg=$('lg-rv-fs'), fsPrev=$('lg-rv-fs-prev'), fsNext=$('lg-rv-fs-next');
  if(fsX) fsX.addEventListener('click', closeLightbox);
  if(fsBg) fsBg.addEventListener('click', function(e){ if(e.target===fsBg) closeLightbox(); });
  if(fsPrev) fsPrev.addEventListener('click', function(e){ e.stopPropagation(); lbPrev(); });
  if(fsNext) fsNext.addEventListener('click', function(e){ e.stopPropagation(); lbNext(); });
  document.addEventListener('keydown', function(e){
    var fs=$('lg-rv-fs');
    if(fs && fs.classList.contains('is-open')){
      if(e.key==='Escape') closeLightbox();
      else if(e.key==='ArrowLeft') lbPrev();
      else if(e.key==='ArrowRight') lbNext();
    }
  });

  /* ---------------- Write review ---------------- */

  function openForm(){
    var dv=$('lg-rv-divider'), fw=$('lg-rv-form-wrap');
    if(dv) dv.classList.add('is-open');
    if(fw){ fw.classList.add('is-open'); fw.scrollIntoView({behavior:'smooth',block:'start'}); }
  }
  function closeForm(){
    var dv=$('lg-rv-divider'), fw=$('lg-rv-form-wrap'), form=$('lg-rv-form');
    if(dv) dv.classList.remove('is-open');
    if(fw) fw.classList.remove('is-open');
    selRating=0; pendingPhotos=[];
    if(form) form.reset();
    var photosEl=$('lg-rv-photos'); if(photosEl) photosEl.innerHTML='';
    var msgEl=$('lg-rv-msg'); if(msgEl){ msgEl.textContent=''; msgEl.className='lg-rv__form-msg'; }
    updateFormStars(0);
  }

  document.querySelectorAll('#lg-rv-write-btn').forEach(function(btn){ btn.addEventListener('click', openForm); });
  var cancelBtn=$('lg-rv-cancel');
  if(cancelBtn) cancelBtn.addEventListener('click', closeForm);

  // CTA quick-rate stars (in the header)
  (function(){
    var wrap=$('lg-rv-cta-stars'); if(!wrap) return;
    var svgs=Array.prototype.slice.call(wrap.querySelectorAll('svg'));
    svgs.forEach(function(svg,i){
      svg.addEventListener('mouseenter', function(){ svgs.forEach(function(s,j){ s.style.fill = j<=i ? '#c4714a' : '#ddd6ca'; }); });
      svg.addEventListener('mouseleave', function(){ svgs.forEach(function(s,j){ s.style.fill = j<selRating ? '#c4714a' : '#ddd6ca'; }); });
      svg.addEventListener('click', function(){
        selRating=i+1;
        svgs.forEach(function(s,j){ s.style.fill = j<selRating ? '#c4714a' : '#ddd6ca'; });
        openForm();
        var radio=$('lgr'+selRating);
        if(radio){ radio.checked=true; updateFormStars(selRating); }
      });
    });
  })();

  // Star picker in the form
  function updateFormStars(val){
    document.querySelectorAll('.lg-rv__star-pick label').forEach(function(lbl,i){
      lbl.style.color = i<val ? '#c4714a' : '#ddd6ca';
    });
  }
  (function(){
    var p=$('lg-rv-star-pick'); if(!p) return;
    var labels=p.querySelectorAll('label'), inputs=p.querySelectorAll('input[type=radio]');
    labels.forEach(function(l,i){
      l.addEventListener('mouseenter', function(){ labels.forEach(function(x,j){ x.style.color=j<=i?'#c4714a':'#ddd6ca'; }); });
      l.addEventListener('mouseleave', function(){ var c=p.querySelector('input:checked'); updateFormStars(c?parseInt(c.value,10):0); });
    });
    inputs.forEach(function(inp){ inp.addEventListener('change', function(){ updateFormStars(parseInt(this.value,10)); }); });
  })();

  // Photo picker — held locally (in pendingPhotos) and only uploaded when the
  // review is submitted. Nothing hits the network at pick time.
  var ua=$('lg-rv-upload'), fi=$('lg-rv-file'), pr=$('lg-rv-photos');
  if(ua&&fi){
    ua.addEventListener('click', function(e){ if(!e.target.closest('.lg-rv__pt-rm')) fi.click(); });
    ua.addEventListener('keydown', function(e){ if(e.key==='Enter'||e.key===' ') fi.click(); });
    ua.addEventListener('dragover', function(e){ e.preventDefault(); ua.style.borderColor='#6d765b'; });
    ua.addEventListener('dragleave', function(){ ua.style.borderColor=''; });
    ua.addEventListener('drop', function(e){ e.preventDefault(); ua.style.borderColor=''; handleFiles(e.dataTransfer.files); });
    fi.addEventListener('change', function(){ handleFiles(fi.files); fi.value=''; });
  }
  function handleFiles(files){
    var rem=3-pendingPhotos.length; if(rem<=0) return;
    Array.from(files).slice(0,rem).forEach(function(f){
      if(!f.type.match(/image\/(jpeg|png|webp)/)) return;
      if(f.size>5*1024*1024){ setMsg('Image too large (max 5MB).','error'); return; }
      var reader=new FileReader();
      reader.onload=function(ev){ addPendingPhoto(ev.target.result, f.name); };
      reader.readAsDataURL(f);
    });
  }
  function addPendingPhoto(dataUrl, fname){
    var id='p'+(pendingSeq++);
    pendingPhotos.push({id:id,dataUrl:dataUrl,filename:fname});
    var wrap=document.createElement('div');
    wrap.className='lg-rv__pt';
    wrap.innerHTML='<img src="'+dataUrl+'" alt="Review photo"><button type="button" class="lg-rv__pt-rm" data-id="'+id+'">&times;</button>';
    wrap.querySelector('button').addEventListener('click', function(){
      pendingPhotos=pendingPhotos.filter(function(p){return p.id!==id;});
      wrap.remove();
    });
    if(pr) pr.appendChild(wrap);
  }

  // Upload all locally-cached photos now; resolve with the array of hosted URLs.
  function uploadPendingPhotos(){
    if(!pendingPhotos.length) return Promise.resolve([]);
    return Promise.all(pendingPhotos.map(function(p){
      return fetch(BASE+'/reviews/upload-image',{
        method:'POST',headers:{'Content-Type':'application/json','X-Keplin-Auth':AUTH},
        body:JSON.stringify({image:p.dataUrl,filename:p.filename})
      }).then(function(r){return r.json();}).then(function(d){
        if(d&&d.url) return d.url;
        throw new Error('Photo upload failed: '+((d&&d.error)||'unknown'));
      });
    }));
  }

  function setSubmitLoading(sb,on){
    if(!sb) return;
    sb.disabled=!!on;
    sb.textContent=on?'Submitting…':'Submit Review';
  }

  // Replace the dialog card contents with a clean, centred success state.
  function showSuccess(discountCode){
    var box=document.querySelector('#lg-rv-form-wrap .lg-rv__form-box');
    if(!box){ setMsg('Thank you! Your review has been submitted and is pending approval.','success'); return; }
    var reward='';
    if(discountCode){
      var applyUrl='/discount/'+encodeURIComponent(discountCode)+'?redirect=/';
      reward=''+
        '<div style="margin-top:22px;background:var(--rv-muted);border:1px solid var(--rv-border);padding:20px 18px;">'+
          '<p style="margin:0 0 6px;font-size:11px;font-weight:700;color:var(--rv-muted-foreground);text-transform:uppercase;letter-spacing:.08em;">Your reward for adding a photo</p>'+
          '<p style="margin:0 0 16px;font-size:26px;font-weight:800;letter-spacing:.12em;color:var(--rv-primary);">'+esc(discountCode)+'</p>'+
          '<div style="display:flex;gap:10px;flex-wrap:wrap;justify-content:center;">'+
            '<a class="rv-btn rv-btn--primary" href="'+applyUrl+'" style="text-decoration:none;">Apply code &amp; shop</a>'+
            '<button type="button" class="rv-btn rv-btn--outline" id="lg-rv-copy" data-code="'+esc(discountCode)+'">Copy code</button>'+
          '</div>'+
        '</div>';
    }
    box.innerHTML=''+
      '<div style="text-align:center;padding:12px 4px 6px;">'+
        '<div style="width:56px;height:56px;margin:0 auto 14px;border-radius:50%;background:var(--rv-primary);color:#fff;display:flex;align-items:center;justify-content:center;font-size:28px;line-height:1;">✓</div>'+
        '<p style="margin:0 0 6px;font-family:var(--rv-serif);font-size:22px;font-weight:500;color:var(--rv-foreground);">Thank you for your review!</p>'+
        '<p style="margin:0;font-size:14px;color:var(--rv-muted-foreground);">It will appear once approved.</p>'+
        reward+
        '<div style="margin-top:22px;"><button type="button" class="rv-btn rv-btn--ghost" id="lg-rv-done">Close</button></div>'+
      '</div>';
    var doneBtn=document.getElementById('lg-rv-done');
    if(doneBtn) doneBtn.addEventListener('click',closeForm);
    var copyBtn=document.getElementById('lg-rv-copy');
    if(copyBtn) copyBtn.addEventListener('click',function(){
      var code=this.getAttribute('data-code'),self=this;
      function done(){ self.textContent='Copied!'; setTimeout(function(){self.textContent='Copy code';},1600); }
      if(navigator.clipboard&&navigator.clipboard.writeText){ navigator.clipboard.writeText(code).then(done,done); }
      else { done(); }
    });
  }

  // Form submit
  var form=$('lg-rv-form');
  if(form){
    form.addEventListener('submit', function(e){
      e.preventDefault();
      var sb=$('lg-rv-submit'); if(sb&&sb.disabled) return;
      var rEl=form.querySelector('input[name="rating"]:checked');
      var rating=rEl?parseInt(rEl.value,10):0;
      var name=($('lg-rv-name')?$('lg-rv-name').value.trim():'')||CUSTOMER_NAME;
      var emailEl=$('lg-rv-email');
      var email=emailEl?emailEl.value.trim():(CUSTOMER_EMAIL||'');
      var title=$('lg-rv-title')?$('lg-rv-title').value.trim():'';
      var body=$('lg-rv-body')?$('lg-rv-body').value.trim():'';

      if(!rating)  { setMsg('Please select a rating.','error'); return; }
      if(!name)    { setMsg('Please enter your name.','error'); return; }
      if(!email)   { setMsg('Please enter your email address.','error'); return; }
      if(!title)   { setMsg('Please add a review title.','error'); return; }
      if(!body)    { setMsg('Please write your review.','error'); return; }

      setSubmitLoading(sb,true);
      setMsg('','');

      // Upload locally-cached photos first, then submit the review.
      uploadPendingPhotos()
        .then(function(photoUrls){
          return fetch(BASE+'/reviews/submit',{
            method:'POST',
            headers:{'Content-Type':'application/json','X-Keplin-Auth':AUTH},
            body:JSON.stringify({
              productId:PRODUCT_ID, productHandle:PRODUCT_HANDLE, productTitle:PRODUCT_TITLE,
              rating:rating, title:title, body:body,
              customerName:name, email:email, photos:photoUrls,
              customerId:CUSTOMER_ID || undefined
            })
          }).then(function(r){ return r.json().then(function(d){return{ok:r.ok,data:d};}).catch(function(){return{ok:r.ok,data:{}};}); });
        })
        .then(function(result){
          if(result.data && result.data.status==='already_reviewed'){
            setMsg('You\'ve already reviewed this product — thank you!','success');
            setSubmitLoading(sb,false);
            return;
          }
          if(!result.ok){
            setMsg((result.data && result.data.error) || 'Something went wrong. Please try again.','error');
            setSubmitLoading(sb,false);
            return;
          }
          showSuccess(result.data && result.data.discountCode);
        })
        .catch(function(err){
          setMsg((err&&err.message)||'Network error. Please try again.','error');
          setSubmitLoading(sb,false);
        });
    });
  }

  function setMsg(t,type){
    var el=$('lg-rv-msg'); if(!el) return;
    el.textContent=t;
    el.className='lg-rv__form-msg'+(type?' lg-rv__form-msg--'+type:'');
  }

  if(/[?&]review=1/.test(window.location.search)){
    setTimeout(function(){ openForm(); }, 700);
  }

  // Boot — hydrate only; #lg-rv-list keeps its server-rendered markup
  // until the person filters/sorts/searches/paginates.
  renderOverall();
  renderBars();
  renderSummary();
  renderGallery();
  updateMetaUI();

})();
